<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">商品企画栄養成分情報メンテナンス</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="element-column">
          <div class="block-row">
            <div class="column-list">
              <label class="list-input-title">Ｐコード</label>
              <div class="list-input-content">
                <input type="text" id="txti_PCode" class="pcode" [ngModel]="kymw0905Model.pCode" readonly>
              </div>
              <label class="list-input-title">アイテムコード</label>
              <div class="list-input-content">
                <input type="text" id="txti_ItemCode" [ngModel]="kymw0905Model.itemCode" class="item-code" readonly>
              </div>
            </div>
            <div class="column-list">
              <label class="list-input-title">商品名</label>
              <div class="list-input-content">
                <input type="text" id="txti_GuideGoodsName" [ngModel]="kymw0905Model.guideGoodsName" class="guide-goods-name" readonly>
              </div>
              <label class="list-input-title">規格名</label>
              <div class="list-input-content">
                <input type="text" id="txti_GuideStandardName" readonly
                  [ngModel]="kymw0905Model.guideStandardName" class="guide-standard-name">
              </div>
            </div>
          </div>
          <div class="column-list">
            <label class="list-input-title">分析単位</label>
            <div class="list-input-content">
              <app-not-null-text-area [restrict]="'[ -￮]'" id="txta_AnalysisUnit" #txta_AnalysisUnit
                [subid]="'txta_AnalysisUnit'" [maxChars]="100" [forcedEnabledMode]="''" [tabindex]="0"
                [(ngModel)]="kymw0905Model.analysisUnit" [required]="true" (input)="eventEditHandler($event)"
                (keydown)="nextFocus($event)" [style.height.px]="70">
              </app-not-null-text-area>
            </div>
          </div>
        </div>
        <div>
          <h1>栄養成分</h1>
          <!-- データグリッド定義 -->
          <div class="element-column">
            <wj-flex-grid [itemsSource]="this.kymw0905Model.nutrientDetailList" class="space-bottom" forcedEnabledMode=""
              #dg_NutrientComponentList id="dg_NutrientComponentList" [headersVisibility]="'Column'"
              [style.height.px]="300" [style.width.px]="904" [tabindex]="0" [selectionMode]="'Row'" [allowSorting]="false"
              (pasting)="onPasting($event)">
              <!-- 表示項目 -->
              <wj-flex-grid-column [minWidth]="5" [header]="'栄養成分名'" [width]="480" [binding]="'NutritionalName'"
                [isReadOnly]="true">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <div [class.nutritional-color]="cell.item.PublishDiv==='1'">
                    {{cell.item.NutritionalName}}
                  </div>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'栄養成分値'" [width]="290" [binding]="'NutritionalQuantity'" [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                  <input type="text" [style.width.%]="100" [style.height.px]="20" autocomplete="off"
                    [style.margin-left.px]="-3" [style.margin-top.px]="-3" [maxlength]="20" [(ngModel)]="cell.value"
                    (input)="eventEditHandler($event)" plessInputTextSub [restrict]="'[ -￮]'"
                    (keydown)="eventGridKeyDownHandler($event,dg_NutrientComponentList,1)" 
                    (blur)="eventQuantity_FOCUSOUTHandler($event, cell)"/>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'単位'" [width]="100" [binding]="'NutritionalUnit'"
                [isReadOnly]="true">
              </wj-flex-grid-column>
              <!-- 非表示項目 -->
              <wj-flex-grid-column [visible]="false" [minWidth]="5" [header]="'vis1'" [binding]="'NutritionalCode'"
                [isReadOnly]="true">
              </wj-flex-grid-column>
              <wj-flex-grid-column [visible]="false" [minWidth]="5" [header]="'vis2'" [binding]="'PublishDiv'"
                [isReadOnly]="true">
              </wj-flex-grid-column>
              <wj-flex-grid-column [visible]="false" [minWidth]="5" [header]="'vis3'" [binding]="'Hirearchy'"
                [isReadOnly]="true">
              </wj-flex-grid-column>
            </wj-flex-grid>
            <div class="column-list">
              <label class="list-input-title">栄養成分備考</label>
              <div class="list-input-content">
                <app-text-area id="txta_NutritionalNote" #txta_NutritionalNote [subid]="'txta_NutritionalNote'"
                  [maxChars]="200" [forcedEnabledMode]="''" [(ngModel)]="kymw0905Model.nutritionalNote"
                  [restrict]="'[ -￮]'" (input)="eventEditHandler($event)" [tabindex]="0" [style.height.px]="111" [fullOnly]="true">
                </app-text-area>
              </div>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Set" forcedEnabledMode="" class="btn-primary" (click)="eventSet_CLICKHandler(null)"
            [tabindex]="0">設定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="eventClose_CLICKHandler()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>